import './FailedChecks.less';
import React, { useMemo } from 'react';
import { Card, Empty } from 'antd';
import LoaderCard from '../shared/LoaderCard';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import { useFetchAffectedClustersQuery } from './service';
import AffectedUrls from './AffectedUrls';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import { SERVICEABLE_URLS_POLLING_TIME_MS } from '../settings';

type Props = {
    websiteGuid: string;
    clusterGuid?: string;
    seoTestKey: string;
};

export default function AffectedUrlClusters({ websiteGuid, clusterGuid, seoTestKey }: Props) {
    const { isRunningBatchAnalysis } = useBatchUrlAnalysisProcessesPolling(websiteGuid);

    const {
        data: affectedClusters,
        isLoading: isLoadingAffectedClusters,
        isFetching: isFetchingAffectedClusters,
    } = useFetchAffectedClustersQuery(
        { w_guid: websiteGuid, seo_test_key: seoTestKey },
        // If we are running an analysis, refetch if the data is older than 30 seconds. This is not polling! refetch will happen only page entry
        { refetchOnMountOrArgChange: isRunningBatchAnalysis ? SERVICEABLE_URLS_POLLING_TIME_MS / 1000 : false }
    );

    const { data: urlClusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });

    const filteredClusters = useMemo(
        () =>
            affectedClusters &&
            affectedClusters.filter((cluster) => cluster.data.length > 0).filter((cluster) => !clusterGuid || cluster.cluster_guid === clusterGuid),
        [affectedClusters, clusterGuid]
    );

    const isLoading = isLoadingAffectedClusters || isLoadingUrlClusters;
    return (
        <>
            {isLoading && <LoaderCard />}

            {filteredClusters && filteredClusters.length === 0 && <Empty description="No URLs failed this test" />}

            {urlClusters &&
                filteredClusters &&
                filteredClusters.map((cluster) => {
                    const clusterData = urlClusters.find((clusterData) => clusterData.guid === cluster.cluster_guid);

                    return (
                        <Card
                            key={cluster.cluster_guid}
                            className="affected-cluster-card"
                        >

                            <Card.Meta
                                title={clusterData?.title}
                                description={clusterData?.description}
                            />

                            <AffectedUrls
                                websiteGuid={websiteGuid}
                                clusterGuid={cluster.cluster_guid}
                                seoTestKey={seoTestKey}
                                sampleUrls={cluster.data}
                                clusterLastEvaluatedKey={cluster.meta.last_evaluated_key}
                                isLoadButtonDisabled={isFetchingAffectedClusters}
                            />
                        </Card >
                    );
                })}
        </>
    );
}
